// removed by extract-text-webpack-plugin
module.exports = {"inputLabel":"_1UhPI2PvCmdq9wVvU3Omyw","inputContainer":"_2jy4YF-KtPVxM3IHpw1A2z","sectionTypeContainer":"_1VrNeauZoXJ8pKhL3fYgCF","sectionContainer":"_1-5RL3hZQaxnJDps2mSCuI","submenuItem":"_1urW_uf4K6nGN8Lr1QCd8M","itemName":"_3fYKS6gtrRxWbp0Qe5eD3f","dropdownBtn":"ukkY65C_1ZHmOpOGyFwnC","dropdownBtnName":"_1HMJDI7oZb5tF6vcDE4D5D","lockedIcon":"_1F2jzRHq4pn1LYIOvzEfMz"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/SectionSelector/SectionSelector.pcss
// module id = 1126
// module chunks = 0